import { OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { AuthGuardService } from '@sc/pas-common';
var ForbiddenComponent = /** @class */ (function () {
    function ForbiddenComponent(router, authGuardService) {
        this.router = router;
        this.authGuardService = authGuardService;
        this.url = environment.server.web.legacy + 'portalscnet/productores/homeproductores.aspx';
    }
    ForbiddenComponent.prototype.goTo = function (e) {
        this.authGuardService.logOut();
    };
    ForbiddenComponent.prototype.ngOnInit = function () {
    };
    ForbiddenComponent.prototype.goToFaq = function (e) {
        this.router.navigate(['/faq']);
    };
    return ForbiddenComponent;
}());
export { ForbiddenComponent };
